import { Share, SquarePlus, Smartphone, X } from 'lucide-react';

interface InstallBannerProps {
  /** 'native' → show an Install button; 'ios' → show Add-to-Home-Screen steps. */
  mode: 'native' | 'ios';
  onInstall: () => void;
  onDismiss: () => void;
}

/**
 * Dismissable "install IOMI Pro" banner.
 *
 * Android / desktop Chromium: the browser gave us a native prompt, so we show
 * a single Install button that triggers it.
 * iOS: Safari has no install API, so we spell out Share → Add to Home Screen.
 */
export function InstallBanner({ mode, onInstall, onDismiss }: InstallBannerProps) {
  return (
    <div className="bg-plum/10 border-b border-plum/20 px-4 py-2.5 flex items-start justify-between gap-3">
      <div className="flex items-start gap-2 min-w-0">
        <Smartphone size={16} className="text-plum shrink-0 mt-0.5" />
        <div className="min-w-0">
          <p className="text-[13px] font-semibold text-midnight">
            Install IOMI Pro on your phone
          </p>
          {mode === 'ios' ? (
            <p className="text-[12px] text-slate leading-snug mt-0.5">
              Tap <Share size={12} className="inline -mt-0.5 text-plum" aria-label="Share" />{' '}
              <span className="font-semibold text-midnight">Share</span>, then{' '}
              <SquarePlus size={12} className="inline -mt-0.5 text-plum" aria-hidden="true" />{' '}
              <span className="font-semibold text-midnight">Add to Home Screen</span>.
            </p>
          ) : (
            <p className="text-[12px] text-slate leading-snug mt-0.5">
              Full-screen, on your home screen, one tap away on site.
            </p>
          )}
        </div>
      </div>
      <div className="flex items-center gap-1 shrink-0">
        {mode === 'native' && (
          <button
            type="button"
            onClick={onInstall}
            className="h-9 px-3 rounded-lg bg-plum text-white text-[12px] font-semibold
                       hover:bg-rose transition-colors"
          >
            Install
          </button>
        )}
        <button
          type="button"
          onClick={onDismiss}
          className="h-11 w-11 -mr-2 rounded-lg text-slate hover:text-midnight flex items-center justify-center
                     transition-colors"
          aria-label="Not now"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
